import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
    selector: 'app-routed-modal',
    template: ``,
    standalone: false
})
export class RoutedModalComponent implements OnDestroy {
    private modalId: string;
    private modalSubscription: Subscription;

    constructor(
        private location: Location,
        private modalService: ModalService,
        private navController: NavController,
        private route: ActivatedRoute
    ) {
        this.modalSubscription = route.data.subscribe(async (data) => {
            if (!data.component) {
                return;
            }

            this.modalId = data.id;

            const modal = await modalService.create({
                component: data.component,
                componentProps: data,
                id: data.id
            });

            await modal.present();

            modal.onWillDismiss().then((event) => {
                if (event.data?.rootPage) { // If we have a root navigate point
                    this.navController.navigateRoot(event.data.rootPage);
                } else if (event.data?.nextPage) { // If we have a navigate point
                    this.navController.navigateForward(event.data.nextPage);
                } else if (event.data?.previousPage) { // If we have a point to return from closing modal manually
                    this.navController.navigateBack(event.data.previousPage, { animated: false, skipLocationChange: false });
                } else { // If we don't have any url we go to the current page url
                    this.navController.navigateBack(this.location.path(), { animated: false, skipLocationChange: true });
                }
            });
        });
    }

    ngOnDestroy(): void {
        this.modalSubscription.unsubscribe();
    }
}
